import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import LightGrayBgWrapper from "../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import PhoneInput from "react-phone-input-2"
import { useState } from "react"
import DynamicDropdown from "../../../common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"
import GeneralBackButton from "../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"

const AddCarrier = () => {
  const [phone, setPhone] = useState(null)

  const supportedCountries = [{ label: "Pakistan" }, { label: "England" }]

  const supportedRegions = [{ label: "Middle East" }, { label: "South Asia" }]

  const paymentTerms = [{ label: "Monthly" }, { label: "Quarterly " }]

  return (
    <LightGrayBgWrapper>
      <div className="bg-white p-3 shadow">
        <GeneralBackButton />
        <div className="fs-5 fw-semibold mb-3">Add Carrier</div>

        <Form onSubmit={(e) => e.preventDefault()}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="carrierName" className="fw-medium">
                  Carrier Name
                </Label>
                <Input id="carrierName" name="carrierName" placeholder="" type="email" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="carrierID" className="fw-medium">
                  Carrier ID
                </Label>
                <Input id="carrierID" name="carrierID" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="emailAddress" className="fw-medium">
                  Email Address
                </Label>
                <Input id="emailAddress" name="emailAddress" placeholder="" type="email" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="contactNumber" className="fw-medium">
                  Contact Number
                </Label>
                <PhoneInput country={"us"} value={phone} onChange={(e) => setPhone(e)} inputClass="w-100" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="website" className="fw-medium">
                  Website
                </Label>
                <Input id="website" name="website" placeholder="" type="email" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="supportedCountries" className="fw-medium">
                  Supported Countries
                </Label>
                <DynamicDropdown options={supportedCountries} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="supportedRegionsCity" className="fw-medium">
                  Supported Regions/City
                </Label>
                <DynamicDropdown options={supportedRegions} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="supportedCountries" className="fw-medium">
                  Supported Countries
                </Label>
                <Input id="supportedCountries" name="supportedCountries" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="supportedRegionsCity" className="fw-medium">
                  Supported Regions/City
                </Label>
                <Input id="supportedRegionsCity" name="supportedRegionsCity" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="supportedCountries" className="fw-medium">
                  Payment Terms
                </Label>
                <DynamicDropdown options={paymentTerms} />
              </FormGroup>
            </Col>
          </Row>

          <div className="my-3 fw-semibold fs-5">Billing Details</div>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="billingContactName" className="fw-medium">
                  Billing Contact Name
                </Label>
                <Input id="billingContactName" name="billingContactName" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="billingEmail" className="fw-medium">
                  Billing Email
                </Label>
                <Input id="billingEmail" name="billingEmail" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="bank" className="fw-medium">
                  Bank
                </Label>
                <Input id="bank" name="bank" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="accountHolderName" className="fw-medium">
                  Account Holder Name
                </Label>
                <Input id="accountHolderName" name="accountHolderName" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="iban" className="fw-medium">
                  IBAN
                </Label>
                <Input id="iban" name="iban" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="swiftCode" className="fw-medium">
                  Swift Code
                </Label>
                <Input id="swiftCode" name="swiftCode" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="apiKey" className="fw-medium">
                  API Key/Token
                </Label>
                <Input id="apiKey" name="apiKey" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="testConnection" className="fw-medium">
                  Test Connection
                </Label>
                <Input id="testConnection" name="testConnection" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="averageDeliveryTime" className="fw-medium">
                  Average Delivery Time
                </Label>
                <Input id="averageDeliveryTime" name="averageDeliveryTime" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="uploadContract" className="fw-medium">
                  Upload Contract
                </Label>
                <Input id="uploadContract" name="uploadContract" placeholder="" type="file" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="status" className="fw-medium">
                  Status
                </Label>
                <Input id="status" name="status" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <FormGroup check inline>
                <Input type="checkbox" />
                <Label check>I agree to Terms & Conditions</Label>
              </FormGroup>
            </div>
            <DynamicButton theme="blue">Submit</DynamicButton>
          </div>
        </Form>
      </div>
    </LightGrayBgWrapper>
  )
}

export default AddCarrier
